import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Page, Wrapper, Paper, Button, ButtonsGroup, Toolbar, Modal, Table, Row, Cell, Tag, Date, LinkClient } from './../../../components/ui';
import { SelectField, OptionField } from './../../../components/ui/input';
import { LeadService } from './../../../services';
import { isUndefined, parseQueryString, findPermissionProps, hasPermission, isRating } from './../../../utilities/utils';
import UtilLeadFilter from './../filter';

import API from './../../../config/api';
import TEXT from './../../../config/text';

class Page__LeadList extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        permission: null,
        name: "...",
        loading: false,
        page: 0,
        total: 0,
        id: null,
        entities: [],
        thead: [
          { id: 'source', name: this.props.t('field.campaign') },
          { id: 'store', name: this.props.t('field.store') },
          { id: 'client', name: `${this.props.t('field.name')}/${this.props.t('field.surname')}` },
          { id: 'email', name: this.props.t('field.email') },
          { id: 'mobile_phone', name: this.props.t('field.phone') },
          { id: 'client', name: this.props.t('field.client') },
          { id: 'created_at', name: this.props.t('field.date') },
          { id: 'rating', name: this.props.t('field.rating') },
          { id: 'actions', name: this.props.t('field.actions'), align: 'right' }
        ],
        leadFilterShow: false,
        ratingModalOpen: false,
        ratingLead: null,
        ratingValue: 'none'
      };
    }

    /**
    * @Event
    * @Description: Is invoked immediately after a component is mounted.
    */
    componentDidMount(){
      this._Init();
    };

    /**
    * @Event
    * @Description: Is invoked immediately after a component will recive props.
    */
    componentDidUpdate(prev_props){

      if(this.props.match.params.page !== prev_props.match.params.page){
        this._All(this.props.match.params.page || 0);
      }

      if(this.props.location.search !== prev_props.location.search){
        this._All(this.props.match.params.page || 0, parseQueryString(this.props.location.search));
      }

    };

    /*
    ** @Event
    ** @Description: Init
    */

    _Init = () => {

      this.setState({ permission: findPermissionProps(this.props.session, API.permissions.leads, this.props.t('text.leads')) });

      const page = this.props.match.params.page || 0;

      if(!isUndefined(page)){
        if(!isNaN(page) && page >= 0){
          this._All(page);
        }else{
          this.props.history.push('/leads');
        }
      }else{
        this._All(this.state.page);
      }

    };

    /*
    ** @Service
    ** @Description: FindAll
    */

    _All = (page) => {

      LeadService.list(page, parseQueryString(this.props.location.search)).then((response) => {

        this.setState({
          loading: true,
          page: !isUndefined(page) ? parseInt(page,10) : 0,
          entities: response.leads,
          total: response.total
        });

      }).catch((error) => {

        // @Dispatch alert error
        this.props.alertShow({
          open: true,
          severity: 'error',
          message: error.data.message ? error.data.message : TEXT.message.error
        });

      });

    };

    /*
    ** @Handle
    ** @Description: Change page
    */

    handleChangePage = (event, page) => {

      // @State
      this.setState({ page: page, loading: false });

      // @History
      this.props.history.push({
        pathname: `/leads/page/${ page }`,
        search: this.props.location.search
      });

    };

    /*
    ** @Event
    ** @Description: Show filter
    */

    handleFilter = () => {
      this.setState({ leadFilterShow: true });
    };

    /*
    ** @Event
    ** @Description: Close filter
    */

    handleFilterClose = () => {
      this.setState({ leadFilterShow: false });
    };

    handleRatingClick = (entity) => {
      this.setState({
        ratingModalOpen: true,
        ratingLead: entity,
        ratingValue: entity.rating || 'none'
      });
    };

    handleRatingClose = () => {
      this.setState({
        ratingModalOpen: false,
        ratingLead: null,
        ratingValue: 'none'
      });
    };

    handleRatingChange = (event) => {
      this.setState({ ratingValue: event.target.value });
    };

    handleRatingSave = () => {
      const { ratingLead, ratingValue } = this.state;
      const payload = { rating: ratingValue === 'none' ? null : ratingValue };

      LeadService.update(ratingLead._id, payload).then(() => {
        this.props.alertShow({
          open: true,
          severity: 'success',
          message: 'Rating actualizado.'
        });
        this.handleRatingClose();
        this._All(this.state.page);
      }).catch((error) => {
        this.props.alertShow({
          open: true,
          severity: 'error',
          message: error.data && error.data.message ? error.data.message : TEXT.message.error
        });
      });
    };

    render(){

      const { session } = this.props;
      const { permission, name, loading, entities, thead, total, page, leadFilterShow, ratingModalOpen, ratingValue } = this.state;

      return(
        <Page>

          <Wrapper>

            <Toolbar
              title={permission ? permission.name : name}
              dividerMobile
            >
              <ButtonsGroup>
                { this.props.location.search !== '' && (
                  <Button
                    icon="cancel"
                    size="medium"
                    color="danger"
                    title="Eliminar filtros"
                    placement="left"
                    component={ NavLink }
                    to="/leads"
                  />
                )}
                <Button
                  icon="filter"
                  size="medium"
                  onClick={ this.handleFilter }
                >
                  {this.props.t('button.filter')}
                </Button>
                { hasPermission(session.user.permissions, API.permissions.leads_management) && (
                  <Button
                    component={ NavLink }
                    to="/leads/create"
                    icon="add"
                    size="medium"
                  >
                    {this.props.t('button.create')}
                  </Button>
                )}
              </ButtonsGroup>
            </Toolbar>

            <Paper disablePadding>

              <Modal
                  status={ leadFilterShow }
                  title={this.props.t('text.filter_leads')}
                  handleCancel={ () => this.handleFilterClose() }
                  maxWidth="sm">
                  <UtilLeadFilter onSuccess={ this.handleFilterClose }/>
              </Modal>

              <Modal
                  status={ ratingModalOpen }
                  title={this.props.t('field.rating')}
                  handleCancel={ this.handleRatingClose }
                  maxWidth="xs"
                  actions={
                    <ButtonsGroup align="right">
                      <Button size="medium" color="danger" onClick={ this.handleRatingClose }>
                        {this.props.t('button.cancel')}
                      </Button>
                      <Button size="medium" color="success" onClick={ this.handleRatingSave }>
                        {this.props.t('button.save')}
                      </Button>
                    </ButtonsGroup>
                  }>
                  <SelectField
                    input={{ value: ratingValue, onChange: this.handleRatingChange }}
                    meta={{ touched: false, error: null }}
                    label={this.props.t('field.rating')}
                  >
                    <OptionField value="none">{this.props.t('field.option_field.none')}</OptionField>
                    <OptionField value="Presupuesto">{this.props.t('field.option_field.presupuesto')}</OptionField>
                    <OptionField value="Compro">{this.props.t('field.option_field.compro')}</OptionField>
                    <OptionField value="No responde">{this.props.t('field.option_field.no_responde')}</OptionField>
                    <OptionField value="Error">{this.props.t('field.option_field.error')}</OptionField>
                  </SelectField>
              </Modal>

              <Table
                thead={ thead }
                loading={ loading }
                total={ total }
                page={ page }
                onChangePage={ this.handleChangePage }
              >
                { entities.length > 0 && (
                  entities.map(entity => {
                    return (
                      <Row key={ entity._id }>
                        <Cell>
                          { entity.source ? (
                            <Tag
                              text={entity.source}
                              color="primary"
                            />
                          ) : (
                            <React.Fragment>
                              -
                            </React.Fragment>
                          )}
                        </Cell>
                        <Cell>
                          { entity.store ? entity.store.name : TEXT.message.not_available }
                        </Cell>
                        <Cell>
                          { entity.name } { entity.surname }
                        </Cell>
                        <Cell>{ entity.email }</Cell>
                        <Cell>{ entity.mobile_phone }</Cell>
                        <Cell>
                          { entity.client ? (
                            <LinkClient client={ entity.client }/>
                          ) : (
                            <React.Fragment>
                              -
                            </React.Fragment>
                          )}
                        </Cell>
                        <Cell>
                          <Date value={ entity.created_at } />
                        </Cell>
                        <Cell>
                          <Button
                            size="small"
                            onClick={ () => this.handleRatingClick(entity) }
                          >
                            { entity.rating ? isRating(entity.rating) : 'null' }
                          </Button>
                        </Cell>
                        <Cell align="right" nowrap>
                          <Button
                            icon="info"
                            component={ NavLink }
                            title={this.props.t('button.information')}
                            to={ `/leads/detail/${ entity._id }` }
                          />
                        </Cell>
                      </Row>
                    )
                  })
                )}

                { (loading && entities.length === 0) && (
                  <Row>
                    <Cell colSpan={ thead.length } align="center">
                      { TEXT.message.without_results }
                    </Cell>
                  </Row>
                )}

              </Table>

            </Paper>

          </Wrapper>

        </Page>
      )
    }

};

const mapStateToProps = (state) => {
  return {
    session: state.userState
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__LeadList));
